import { createReducer, on, Action } from '@ngrx/store';

import * as fromActions from '../actions/account-settings.actions';
import { UserInformation } from '../../../settings/account-settings/account-settings.model';

export interface AccountSettings {
  userData: UserInformation;
  loading: boolean;
  loaded: boolean;
}

export const initialState: AccountSettings = {
  userData: <UserInformation>{
    firstName: '',
    lastName: '',
    companyName: '',
    pushNotificationEnabled: false,
  },
  loading: false,
  loaded: false,
};

const _accountSettingsReducer = createReducer(
  initialState,
  on(
    fromActions.changePassword,
    fromActions.refreshUserData,
    fromActions.updateNotifications,
    (state: AccountSettings) => ({ ...state, loading: true, loaded: false }),
  ),

  on(fromActions.changePasswordSuccess, (state: AccountSettings) => (
    { ...state, loading: false, loaded: true }
  )),
  on(fromActions.updateUserInfoSuccess, (state: AccountSettings, { payload }) => (
    { ...state, userData: payload, loading: false, loaded: true }
  )),

  on(fromActions.refreshUserDataSuccess, (state: AccountSettings, action) => {
    const userData: UserInformation = { ...action.payload };

    return { ...state, userData, loading: false, loaded: true };
  }),
  on(fromActions.updateNotificationsSuccess, (state: AccountSettings, action) => {
    const userData = { ...state.userData };
    userData.pushNotificationEnabled = action.payload;

    return { ...state, userData, loading: false, loaded: true };
  }),
  on(
    fromActions.updateNotificationsFailed,
    fromActions.changePasswordFailed,
    (state: AccountSettings) => ({ ...state, loading: false, loaded: false }),
  ),
);

export function accountSettingsReducer(
  state: AccountSettings = initialState,
  action: Action,
): AccountSettings {
  return _accountSettingsReducer(state, action);
}
